<template>
  <div class="details-sub-tabs-case">
    <div class="details-sub-tabs-case-information">
      <div
        v-for="(value, key) in caseInformation"
        :key="`${value}-${key}`"
        class="details-sub-tabs-case-information-items"
        :class="`details-sub-tabs-case-information-items--${key}`">
        <div class="details-sub-tabs-case-information-items--header">
          <span>{{ getKeyName(key) }}</span>
        </div>
        <div
          :class="[
            'details-sub-tabs-case-information-items--contents',
            {
              'details-sub-tabs-case-information-items--contents--value': value,
            },
          ]"
          @click="copyToClipboard(value)">
          <span
            v-if="key === `Disputed_amount` || key === `Bulk_dispute`"
            v-tooltip="value">
            {{ value }}
          </span>
          <span
            v-else-if="key === `Fscm_created_at` || key === `Fscm_changed_at`"
            v-tooltip="getDate(value)">
            {{ getDate(value) }}
          </span>
          <span
            v-else-if="key === `Charge_code`"
            v-tooltip="value ? getChargeCodeValue(value) : '-'">
            {{ value ? getChargeCodeValue(value) : "-" }}
          </span>
          <span v-else v-tooltip="value">{{ value || "-" }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import { showToast } from "@/components/common/Toast";

// Helpers
import { copyToClipboardDebounced } from "@/utils/helpers";
import { format } from "date-fns";

export default {
  name: "DisputeInformation",
  props: {
    caseInformation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showingClipboardToast: false,
    };
  },
  methods: {
    getKeyName(key) {
      const regex = /_/g;
      return key.replace(regex, " ");
    },
    copyToClipboard(value) {
      if (value) {
        copyToClipboardDebounced(
          value,
          this.showingClipboardToast,
          showToast,
          this.$copyText
        );
      }
    },
    getDate(value) {
      return value ? format(new Date(value), "dd-MMM-yyyy hh:mm a") : "N/A";
    },
    getChargeCodeValue(value) {
      let chargeCodeValue;
      value.split("+").forEach((value) => {
        chargeCodeValue = chargeCodeValue
          ? chargeCodeValue + "+" + value?.split("-")?.[0]
          : value?.split("-")?.[0];
      });
      return chargeCodeValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.details-sub-tabs-case {
  background: var(--Gray-50);
  border: 1px solid var(--Gray-100);
  box-shadow: 0px 1px 5px var(--black-variant-1),
    0px 3px 1px -2px var(--black-variant-1), 0px 2px 2px var(--black-variant-1);
  padding: 1.5rem;

  &-information {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;

    &-items {
      margin-bottom: 1rem;

      &--header {
        font-size: 0.875rem;
        color: var(--Gray-600);
      }

      &--contents {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        & span {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 10rem;
          cursor: pointer;
        }

        &--value {
          &:hover {
            &::after {
              margin-right: 2.5rem;
              content: "\2752";
            }
          }
        }
      }
    }
  }
}
</style>
